<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col">
                <h3 class="page-title">Statistik Harian</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Statistik Harian</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="row filter-row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-4">Brand</label>
                    <div class="col-md-8">
                      <multiselect
                        v-model="selectedContact"
                        id="ajax"
                        label="license_name"
                        track-by="id"
                        :placeholder="'Type to search Brand...'"
                        :multiple="true"
                        open-direction="bottom"
                        :custom-label="customLabel"
                        :options="contactOptions"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :close-on-select="false"
                        :options-limit="300"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="asyncFind"
                        :show-labels="false"
                      >
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <span>{{ option.name }}</span>
                            <span class="custom__remove" @click="remove(option)"
                              >❌</span
                            >
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div
                            class="multiselect__clear"
                            v-if="selectedContact.length"
                            @mousedown.prevent.stop="clearAll(props.search)"
                          ></div>
                        </template>
                        <span slot="noResult">Oops! No elements found.</span>
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group form-focus">
                    <input
                      v-model="formDataReport.date"
                      class="form-control floating"
                      type="date"
                    />
                    <label class="focus-label sr-only">Tanggal</label>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group form-focus">
                    <a
                      href="#"
                      data-toggle="modal"
                      :data-target="
                        (formDataReport.brand_id != '' &&
                          formDataReport.date != '') &&
                          '#report_form'
                      "
                      @click.prevent="showReportForm"
                      class="btn btn-success btn-block"
                      >Submit</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Search Filter -->

          <div style="text-align: center; margin-top: 32px;">
            Silakan pilih Brand dan Tanggal untuk melihat laporan.
          </div>
        </div>
      </div>
      <report />
      <!-- Page Wrapper -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import { Skeleton } from "vue-loading-skeleton";

import Report from "./components/reportAgent";

export default {
  name: "StatistikHarian",
  components: {
    Multiselect,
    Skeleton,
    Report
  },
  data() {
    return {
      formDataReport: {
        date: "",
        brand_id: ""
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isLoading: false
    };
  },
  async created() {
    await this.asyncFind("");
  },
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
          // this.asyncFindProduct()
        }
        if (val.length == 1) {
          // this.productOptions = [];
          // this.selectedProduct = [];
          this.formDataReport.brand_id = val[0].id;
          // this.asyncFindProduct();
          // this.searchData();
        } else {
          // this.productOptions = [];
          // this.selectedProduct = [];
          this.formDataReport.brand_id = "";
          // this.searchData();
        }
      },
      deep: true
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    async clearData() {
      this.selectedContact = [];
      this.formDataReport.date = "";
      this.formDataReport.brand_id = "";
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/listAgent", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          if (this.columnFilters.brand_id) {
            this.contactOptions.forEach(item => {
              if (item.id == this.columnFilters.brand_id) {
                this.selectedContact.push(item);
              }
            });
            // this.asyncFindProduct();
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    showReportForm() {
      if (
        this.formDataReport.brand_id == "" ||
        this.formDataReport.date == ""
      ) {
        this.$fire({
          title: "Error",
          text: "Isi brand dan tanggal terlebih dahulu.",
          type: "error",
          timer: 2000
        });
        return;
      }

      this.$store.dispatch("monitoring/setIsShowFormReport", false);
      this.$store.dispatch(
        "monitoring/actFormParamReport",
        this.formDataReport
      );
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("report_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowFormReport", true);
        }
      }, 1000);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/monitoring/summary/reportAgent.vue